import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import ImpersondatePopup from './impersonate-popup/impersonate-popup';
import { consoleAPI } from '@/providers/apis/console/console';
import { SessionModel } from '@/models/auth/session';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'impersonate-list',
    components: {
        'material-icon': GoogleMaterialIcon,
        'impersonate-popup': ImpersondatePopup,
    },
})

export default class ImpersonateList extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    /**
     * Holding the filter options
     */
    private searchBy: Array<{title: string, key: string, isActive: boolean}> = [
        {
            title: 'Email ID',
            key: 'emailId',
            isActive: true,
        },
        {
            title: 'User ID',
            key: 'userId',
            isActive: false,
        },
        {
            title: 'Username',
            key: 'username',
            isActive: false,
        },
    ];

    /**
     * Help to show filter dropdown
     */
    private isShowDropDown: boolean = false;

    /**
     * Holding the search terms string
     */
    private searchTerms: string = '';

    /**
     * Help to maintain the active search
     */
    private get selectedSearch() {
        return this.searchBy.find((item) => item.isActive);
    }

    /**
     * filterParams have the filter properties
     */
    private filterParams: any = {
        offset: 0,
        limit: 10,
    };

    /**
     * userList having the list of impersonating users
     */
    private get userList() {
        return this.$store.state.impersonateStore.impersonateUsers;
    }

    private isShowPopup: boolean = false;

    // ------------------------------------------------------------------------
    // Hooks
    private created() {
        this.$store.dispatch('impersonateStore/fetchImpersonateUser', this.filterParams);
    }

    // ------------------------------------------------------------
    // Actions
    /**
     * Actions trigger when we click on the filter
     * @param search
     */
    private onSelectSearch(search: any) {
        this.searchBy.map((user) => user.isActive = false);
        this.$set(search, 'isActive', true);
        this.isShowDropDown = false;
    }

    private onSelectUser(userId: string) {
        consoleAPI.getImpersonateLogin(userId)
            .then((user) => {
            if (Object.keys(user).length) {
                user.isImpersonateUser = true;
                this.$access.updateRole(user, false);
            }
        });
        this.isShowPopup = !this.isShowPopup;
    }

    /**
     * Action trigger when click enter button
     * @param terms
     */
    private onSearch(terms: string) {
        const params = this.filterParams;
        const activeFilter = this.searchBy.find((filter) => filter.isActive);
        if (activeFilter) {
            params.filterBy = activeFilter.key;
            params.query = terms;
        }
        this.$store.dispatch('impersonateStore/fetchImpersonateUser', params);
    }

    private onClose(isShowPopup: boolean) {
        this.isShowPopup = isShowPopup;
    }
}
